import store from '@/store'

export function trans(value) {

    if(!value) return ''

    let lowerCaseValue = value.toString().toLowerCase()
    if(store) {
        let storeTranslations = store.getters.translations
        
        if(storeTranslations[lowerCaseValue]) {
            return storeTranslations[lowerCaseValue].it
        }
    }

    return typeof FALLBACK_TRANSLATIONS[lowerCaseValue] === 'undefined' ? value : FALLBACK_TRANSLATIONS[lowerCaseValue]
}

// Tutte le traduzioni di trans() (chiave minuscola → testo): l'export CSV le manda al backend,
// che scrive le celle "trans" come le mostra la tabella
trans.dictionary = function () {
    const dictionary = { ...FALLBACK_TRANSLATIONS }
    const storeTranslations = (store && store.getters.translations) || {}
    // trans() cerca nello store la chiave già in minuscolo: le altre non vengono mai trovate
    Object.keys(storeTranslations).filter(key => key === key.toLowerCase()).forEach(key => {
        dictionary[key] = storeTranslations[key].it
    })
    return dictionary
}

const FALLBACK_TRANSLATIONS = {
    profile: 'Profilo',
    users: 'Utenti',
    user: 'Utente',
    roles: 'Ruoli',
    role: 'Ruolo',
    groups: 'Gruppi',
    group: 'Gruppo',
    new_group: 'Nuovo Gruppo',
    crm: 'Crm',
    contacts: 'Contatti',
    companycontacts: 'Contatti Aziende',
    companycontact: 'Contatto Azienda',
    suppliercontacts: 'Contatti Fornitori',
    suppliercontact: 'Contatto Fornitore',
    new_suppliercontact: 'Nuovo Contatto Fornitore',
    new_companycontact: 'Nuovo Contatto Azienda',
    contact: 'Contatto',
    companies: 'Aziende',
    company: 'Azienda',
    leads: 'Lead',
    lead: 'Lead',
    new_lead: 'Nuovo Lead',
    edit_lead: 'Modifica Lead',
    prospects: 'Prospect',
    prospect: 'Prospect',
    new_prospect: 'Nuovo Prospect',
    edit_prospect: 'Modifica Prospect',
    products: 'Prodotti',
    product: 'Prodotto',
    lots: 'Lotti',
    lot: 'Lotto',
    new_lot: 'Nuovo Lotto',
    serials: 'Matricole',
    serial: 'Matricola',
    new_serial: 'Nuova Matricola',
    categories: 'Categorie',
    categoy: 'Categoria',
    ddts: 'DDT di Vendita',
    ddt: 'DDT di Vendita',
    ddtproduct: 'Prodotto DDT',
    purchaseddts: 'DDT di Acquisto',
    purchaseddt: 'DDT di Acquisto',
    carriers: 'Vettori',
    carrier: 'Vettore',
    shippingcosts: 'Costi Spedizione',
    projects: 'Progetti',
    project: 'Progetto',
    compliance: 'SGI / Compliance',
    compliancedashboard: 'Dashboard SGI',
    compliancesoa: 'Dichiarazione di Applicabilità (SoA)',
    compliancedocuments: 'Documenti SGI',
    compliancedocument: 'Documento SGI',
    new_compliancedocument: 'Nuovo Documento SGI',
    edit_compliancedocument: 'Modifica Documento SGI',
    compliancenonconformities: 'Non Conformità',
    compliancenonconformity: 'Non Conformità',
    new_compliancenonconformity: 'Nuova Non Conformità',
    edit_compliancenonconformity: 'Modifica Non Conformità',
    complianceaudits: 'Audit',
    complianceaudit: 'Audit',
    new_complianceaudit: 'Nuovo Audit',
    edit_complianceaudit: 'Modifica Audit',
    compliancerisks: 'Rischi',
    compliancerisk: 'Rischio',
    new_compliancerisk: 'Nuovo Rischio',
    edit_compliancerisk: 'Modifica Rischio',
    complianceassets: 'Asset',
    complianceasset: 'Asset',
    new_complianceasset: 'Nuovo Asset',
    edit_complianceasset: 'Modifica Asset',
    compliancesoaitems: 'Dichiarazione di Applicabilità',
    compliancesoaitem: 'Controllo SoA',
    complianceauditprogram: 'Programma Audit',
    compliancereviews: 'Riesame della Direzione',
    compliancemanagementreview: 'Riesame della Direzione',
    new_compliancemanagementreview: 'Nuovo Riesame della Direzione',
    edit_compliancemanagementreview: 'Modifica Riesame della Direzione',
    complianceobjectives: 'Obiettivi e Indicatori',
    complianceobjective: 'Obiettivo',
    new_complianceobjective: 'Nuovo Obiettivo',
    edit_complianceobjective: 'Modifica Obiettivo',
    compliancecontextissues: 'Analisi del Contesto',
    compliancecontextissue: 'Fattore di Contesto',
    new_compliancecontextissue: 'Nuovo Fattore di Contesto',
    edit_compliancecontextissue: 'Modifica Fattore di Contesto',
    compliancestakeholders: 'Parti Interessate',
    compliancestakeholder: 'Parte Interessata',
    new_compliancestakeholder: 'Nuova Parte Interessata',
    edit_compliancestakeholder: 'Modifica Parte Interessata',
    complianceincidents: 'Incidenti di Sicurezza',
    complianceincident: 'Incidente di Sicurezza',
    new_complianceincident: 'Nuovo Incidente di Sicurezza',
    edit_complianceincident: 'Modifica Incidente di Sicurezza',
    compliancesupplierevaluations: 'Valutazione Fornitori',
    compliancesupplierevaluation: 'Valutazione Fornitore',
    new_compliancesupplierevaluation: 'Nuova Valutazione Fornitore',
    edit_compliancesupplierevaluation: 'Modifica Valutazione Fornitore',
    compliancecompetences: 'Competenze e Formazione',
    compliancecompetence: 'Competenza',
    new_compliancecompetence: 'Nuova Competenza',
    edit_compliancecompetence: 'Modifica Competenza',
    opportunities: 'Opportunità',
    opportunity: 'Opportunità',
    quotations: 'Preventivi',
    quotation: 'Preventivo',
    productquotation: 'Prodotto Preventivo',
    tasks: 'Tasks',
    task: 'Task',
    taskboard: 'Taskboard',
    assets: 'Asset',
    asset: 'Asset',
    assetproduct: 'Prodotti Asset',
    vehicles: 'Veicoli',
    vehicle: 'Veicolo',
    hr: 'Risorse Umane',
    hremployee: 'Dipendente',
    hremployees: 'Dipendenti',
    hrdepartment: 'Reparto',
    hrdepartments: 'Reparti',
    hrjobtitle: 'Mansione',
    hrjobtitles: 'Mansioni',
    hrskill: 'Competenza',
    hrskills: 'Competenze',
    hrcontract: 'Contratto',
    hrcontracts: 'Contratti',
    hrworkplace: 'Luogo di Lavoro',
    hrworkplaces: 'Luoghi di Lavoro',
    hrclockdevice: 'Dispositivo Timbratura',
    hrclockdevices: 'Dispositivi Timbratura',
    hrshifttemplate: 'Turno',
    hrshifttemplates: 'Turni',
    hrclock: 'Timbratura',
    hrclocks: 'Timbrature',
    hrworkingday: 'Cartellino',
    hrworkingdays: 'Cartellino',
    hrabsencetype: 'Tipo Assenza',
    hrabsencetypes: 'Tipi Assenza',
    hrabsence: 'Assenza',
    hrabsences: 'Ferie e Permessi',
    hrleavebalance: 'Residuo',
    hrleavebalances: 'Residui',
    hrtimeline: 'Timeline Giornata',
    hrpayslip: 'Busta Paga',
    hrpayslips: 'Buste Paga',
    hrpayslipimport: 'Import Buste Paga',
    hrpayslipimports: 'Import Buste Paga',
    hremployeeimport: 'Import Dati HR',
    hremployeeimports: 'Import Dati HR',
    hrimport: 'Import Dati HR',
    hrimports: 'Import Dati HR',
    hrccnl: 'CCNL',
    hrccnls: 'CCNL',
    hrtickettimesheet: 'Timesheet Ticket',
    hrtickettimesheets: 'Timesheet Ticket',
    hrexpensereport: 'Report Spese',
    hrexpensereports: 'Report Spese',
    hrexpense: 'Nota Spesa',
    hrexpenses: 'Note Spese',
    hrtraining: 'Corso',
    hrtrainings: 'Formazione',
    hremployeetraining: 'Iscrizione Corso',
    hremployeetrainings: 'Iscrizioni Corso',
    hrperformancereview: 'Performance Review',
    hrperformancereviews: 'Performance Review',
    hronboarding: 'Onboarding',
    hronboardings: 'Onboarding',
    hronboardingtemplate: 'Template Onboarding/Offboarding',
    hronboardingtemplates: 'Template Onboarding/Offboarding',
    hrreport: 'Report HR',
    hrreports: 'Report HR',
    hrgpsproviderconfig: 'Provider GPS',
    hrgpsproviderconfigs: 'Provider GPS',
    hrvehiclegpstrack: 'Traccia GPS',
    hrgpstracks: 'Tracce GPS',
    // Titoli dialog Create/Edit per le entità HR (pattern: new_<singolare>, edit_<singolare>)
    new_hrdepartment: 'Nuovo Reparto',
    edit_hrdepartment: 'Modifica Reparto',
    new_hrjobtitle: 'Nuova Mansione',
    edit_hrjobtitle: 'Modifica Mansione',
    new_hrskill: 'Nuova Competenza',
    edit_hrskill: 'Modifica Competenza',
    new_hrcontract: 'Nuovo Contratto',
    edit_hrcontract: 'Modifica Contratto',
    new_hrpayslip: 'Nuova Busta Paga',
    edit_hrpayslip: 'Modifica Busta Paga',
    new_hrtickettimesheet: 'Nuovo Timesheet',
    edit_hrtickettimesheet: 'Modifica Timesheet',
    new_hrexpensereport: 'Nuovo Report Spese',
    edit_hrexpensereport: 'Modifica Report Spese',
    new_hrexpense: 'Nuova Nota Spesa',
    edit_hrexpense: 'Modifica Nota Spesa',
    new_hrtraining: 'Nuovo Corso',
    edit_hrtraining: 'Modifica Corso',
    new_hremployeetraining: 'Nuova Iscrizione Corso',
    edit_hremployeetraining: 'Modifica Iscrizione Corso',
    new_hrperformancereview: 'Nuova Performance Review',
    edit_hrperformancereview: 'Modifica Performance Review',
    new_hronboardingtemplate: 'Nuovo Template Onboarding/Offboarding',
    edit_hronboardingtemplate: 'Modifica Template Onboarding/Offboarding',
    new_hremployeeonboarding: 'Nuovo Onboarding',
    edit_hremployeeonboarding: 'Modifica Onboarding',
    new_hrgpsproviderconfig: 'Nuovo Provider GPS',
    edit_hrgpsproviderconfig: 'Modifica Provider GPS',
    new_hrannouncement: 'Nuovo Avviso',
    edit_hrannouncement: 'Modifica Avviso',
    new_hrwebhook: 'Nuovo Webhook',
    edit_hrwebhook: 'Modifica Webhook',
    new_hrreportschedule: 'Nuova Schedulazione Report',
    edit_hrreportschedule: 'Modifica Schedulazione Report',
    hrannouncement: 'Avviso',
    hrannouncements: 'Bacheca avvisi',
    hrwebhook: 'Webhook',
    hrwebhooks: 'Webhook integrazioni',
    // Voci virtuali HR (accordion menu, non sono entità ma containers)
    hrattendance: 'Presenze',
    hrcompensation: 'Retribuzione',
    hrorgchart: 'Organigramma',
    hrtalent: 'Talent',
    hrapprovals: 'Approvazioni',
    hrsettings: 'Risorse Umane',
    // Sub-entità HR usate in form/audit
    hremployeeshift: 'Turno Dipendente',
    hremployeeshifts: 'Turni Dipendenti',
    hremployeeskill: 'Competenza Dipendente',
    hremployeeskills: 'Competenze Dipendenti',
    hremployeetraining: 'Iscrizione Corso',
    hremployeetrainings: 'Iscrizioni Corso',
    hremployeeonboarding: 'Onboarding Dipendente',
    hremployeeonboardings: 'Onboarding Dipendenti',
    hremployeeonboardingtask: 'Task Onboarding',
    hremployeeonboardingtasks: 'Task Onboarding',
    hrshiftslot: 'Slot Turno',
    hrshiftslots: 'Slot Turno',
    hronboardingtask: 'Task Template Onboarding',
    hronboardingtasks: 'Task Template Onboarding',
    hrperformancegoal: 'Obiettivo Performance',
    hrperformancegoals: 'Obiettivi Performance',
    expiration: 'Scadenza',
    expirations: 'Scadenze',
    vehicleexpiration: 'Scadenza Veicolo',
    vehicleexpirations: 'Scadenze Veicoli',
    new_vehicleexpiration: 'Nuova Scadenza Veicolo',
    tasklists: 'Tasklists',
    tasklist: 'Tasklist',
    new_calendar: 'Nuovo Calendario',
    calendar: 'Calendario',
    calendars: 'Calendari',
    timecards: 'Timecards',
    timecard: 'Timecard',
    dashboard: 'Dashboard',
    settings: 'Impostazioni',
    tickets: 'Ticket',
    true: 'Disattivo',
    false: 'Attivo',
    owner: 'Proprietario',
    group: 'Gruppo',
    customer: 'Cliente',
    new: 'Nuovo',
    contacted: 'Contattato',
    scheduled_meeting: 'Incontro Programmato',
    quotation_sent: 'Preventivo Inviato',
    approved: 'Accettato',
    suspended: 'Sospeso',
    archived: 'Archiviato',
    companycategories: 'Categorie Aziende',
    companycategory: 'Categoria Azienda',
    companyareas: 'Aree Aziende',
    companyarea: 'Area Azienda',
    productcategories: 'Categorie Prodotti',
    productcategory: 'Categoria Prodotto',
    agents: 'Agenti',
    agent: 'Agente',
    commissions: 'Provvigioni',
    destination: 'Destinazione',
    destinations: 'Destinazioni',
    companydestination: 'Destinazioni Azienda',
    companydestinations: 'Destinazioni Aziende',
    supplierdestination: 'Destinazioni Fornitore',
    supplierdestinations: 'Destinazioni Fornitori',
    new_companydestination: 'Nuova Destinazione Azienda',
    new_supplierdestination: 'Nuova Destinazione Fornitore',
    productsupplier: 'Prodotto Fornitore',
    productsuppliers: 'Prodotti Fornitori',
    contractcodes: 'Codice Appalto',
    contractcodes: 'Codici Appalti',
    sectionals: 'Sezionali',
    sectional: 'Sezionale',
    attachments: 'Documenti',
    show: 'Visualizzazione',
    create: 'Creazione',
    edit: 'Modifica',
    delete: 'Eliminazione',
    index: 'Index',
    show_cost: 'Mostra costi',
    contractors: 'Appaltatori',
    contractor: 'Appaltatore',
    contracts: 'Contratti',
    contract: 'Contratto',
    trouble: 'Ticket',
    troubles: 'Ticket',
    portal: 'Area Clienti',
    portalusers: 'Accessi Clienti',
    drive: 'Drive',
    mail_signature: 'Firma Mail',
    mail_signatures: 'Firme Mail',
    new_contact: 'Nuovo Contatto',
    new_company: 'Nuova Azienda',
    edit_company: 'Modifica Azienda',
    new_destination: 'Nuova Destinazione',
    new_opportunity: 'Nuova Opportunità',
    edit_opportunity: 'Modifica Opportunità',
    pipeline_opportunity: 'Pipeline Opportunità',
    associated_opportunities: 'Opportunità associate',
    no_opportunities_found: 'Nessuna opportunità trovata',
    new_quotation: 'Nuovo Preventivo',
    new_ddt: 'Nuovo DDT di Vendita',
    new_purchaseddt: 'Nuovo DDT di Acquisto',
    new_carrier: 'Nuovo Vettore',
    new_project: 'Nuovo Progetto',
    new_timecard: 'Nuova Timecard',
    new_product: 'Nuovo Prodotto',
    new_asset: 'Nuovo Asset',
    new_vehicle: 'Nuovo Veicolo',
    new_hremployee: 'Nuovo Dipendente',
    edit_hremployee: 'Modifica Dipendente',
    new_hrworkplace: 'Nuovo Luogo di Lavoro',
    edit_hrworkplace: 'Modifica Luogo di Lavoro',
    new_hrclockdevice: 'Nuovo Dispositivo Timbratura',
    edit_hrclockdevice: 'Modifica Dispositivo Timbratura',
    new_hrshifttemplate: 'Nuovo Turno',
    edit_hrshifttemplate: 'Modifica Turno',
    new_hrclock: 'Nuova Timbratura',
    edit_hrclock: 'Modifica Timbratura',
    new_hrabsencetype: 'Nuovo Tipo Assenza',
    edit_hrabsencetype: 'Modifica Tipo Assenza',
    new_hrabsence: 'Nuova Richiesta',
    edit_hrabsence: 'Modifica Richiesta',
    new_expiration: 'Nuova Scadenza',
    new_task: 'Nuovo Task',
    new_agent: 'Nuovo Agente',
    new_trouble: 'Nuovo Ticket',
    new_intervention: 'Nuovo Intervento',
    interventionproduct: 'Prodotto Intervento',
    interventionsproducts: 'Prodotti Intervento',
    maintenance: 'Manutenzione',
    new_contractor: 'Nuovo Appaltatore',
    new_contract: 'Nuovo Contratto',
    new_user: 'Nuovo Utente',
    new_role: 'Nuovo Role',
    new_mail_signature: 'Nuova Firma Mail',
    new_companycategory: 'Nuova Categoria Azienda',
    new_companyarea: 'Nuova Area Azienda',
    new_productcategory: 'Nuova Categoria Prodotto',
    new_sectional: 'Nuovo Sezionale',
    new_company_status: 'Nuovo tipo Azienda',
    vat: 'IVA',
    new_vat: 'Nuova Aliquota IVA',
    product_quotation_type: 'Tipo di costo',
    new_product_quotation_type: 'Nuovo Tipo di costo',
    opportunity_status: 'Stato Opportunità',
    new_opportunity_status: 'Nuovo Stato Opportunità',
    payment_method: 'Metodo di Pagamento',
    new_payment_method: 'Nuovo Metodo di Pagamento',
    payment_term: 'Termine di Pagamento',
    new_payment_term: 'Termini di Pagamento',
    asset_type: 'Tipo Asset',
    new_asset_type: 'Nuovo Tipo Asset',
    vehicle_type: 'Tipo Veicolo',
    new_vehicle_type: 'Nuovo Tipo Veicolo',
    vehicle_fuel_type: 'Tipo Carburante',
    new_vehicle_fuel_type: 'Nuovo Tipo Carburante',
    expiration_type: 'Tipo Scadenza',
    new_expiration_type: 'Nuovo Tipo Scadenza',
    mailmarketing: 'Mail Marketing',
    callcenter: 'Call Center',
    new_mail_template: 'Nuova Template Mail',
    mail_template: 'Template Mail',
    mail_scheduling: 'Regola di invio mail',
    new_mail_scheduling: 'Nuova Regola di invio mail',
    supplier: 'Fornitore',
    suppliers: 'Fornitori',
    new_supplier: 'Nuovo Fornitore',
    edit_supplier: 'Modifica Fornitore',
    tenant: 'Tenant',
    new_tenant: 'Nuovo Tenant',
    orders: 'Ordini',
    saleorders: 'Ordini di Vendita',
    productsaleorder: 'Prodotto ordine di vendita',
    saleorder: 'Ordine di Vendita',
    new_saleorder: 'Nuovo Ordine di Vendita',
    purchaseorders: 'Ordini di Acquisto',
    productpurchaseorder: 'Prodotto Ordine di Acquisto',
    productpurchaseddt: 'Prodotto DDT di Acquisto',
    purchaseorder: 'Ordine di Acquisto',
    new_purchaseorder: 'Nuovo Ordine di Acquisto',
    picklist: 'Lista di Prelievo',
    loadinglist: 'Lista di Carico',
    new_loom: 'Nuovo Telaio',
    loom: 'Telaio',
    looms: 'Telai',
    banci: 'Banci',
    marbec: 'Marbec',
    commercial: 'Commerciale',
    interventions: 'Interventi',
    intervention: 'Intervento',
    tariffs: 'Tariffari',
    tariff: 'Tariffario',
    visit: 'Manutenzione',
    visits: 'Manutenzioni',
    new_tariff: 'Nuovo Tariffario',
    report: 'Report',
    helpdeskreports: 'Report Helpdesk',
    attributes: 'Attributi',
    attribute: 'Attributo',
    new_attribute: 'Nuovo Attributo',
    save_primary_message: 'Uscire senza salvare?',
    save_secondary_message: 'Se esci senza salvare le modifiche andranno perse. Premi Annulla per rimanere nella schermata corrente.',
    pricelists: 'Listini',
    pricelist: 'Listino',
    pricelist_pricelist: 'Listino Anagrafico',
    new_pricelist_pricelist: 'Nuovo Listino Anagrafico',
    new_pricelist: 'Nuovo Listino',
    variable: 'Variabile',
    variant: 'Variante',
    simple: 'Semplice',
    production: 'Produzione',
    production_manager: 'Manager Produzione',
    description: 'Descrizione',
    manual: 'Manuale',
    movements: 'Movimenti',
    movement: 'Movimento',
    unload: 'Scarico',
    load: 'Carico',
    new_supplierdestination: 'Nuova Destinazione fornitore',
    supplierdestination: 'Destinazione Fornitore',
    supplierdestinations: 'Destinazioni Fornitori',
    unsolveds: 'Insoluti',
    deadlines: 'Scadenze',
    document_id: 'Documento',
    deadline: 'Scadenza',
    companydeadlines: 'Scadenze Aziende',
    companydeadline: 'Scadenza Azienda',
    supplierdeadlines: 'Scadenze Fornitori',
    supplierdeadline: 'Scadenza Fornitore',
    new_companydeadline: 'Nuova Scadenza Azienda',
    new_supplierdeadline: 'Nuova Scadenza Fornitore',
    new_deadline: 'Nuova Scadenza',
    companypayments: 'Pagamenti',
    companypayment: 'Pagamento',
    new_companypayment: 'Nuovo Pagamento',
    supplierpayments: 'Pagamenti Fornitori',
    supplierpayment: 'Pagamento Fornitore',
    new_supplierpayment: 'Nuovo Pagamento',
    analytics: 'Statistiche',
    soldproducts: 'Vendite',
    purchasedproducts: 'Acquisti',
    revenuecategories: 'Categorie Clienti',
    widgets: 'Widget',
    widget: 'Widget',
    new_widget: 'Nuovo Widget',
    edit_widget: 'Modifica Widget',
    dashboards: 'Dashboard',
    dashboard: 'Dashboard',
    new_dashboard: 'Nuova Dashboard',
    edit_dashboard: 'Modifica Dashboard',
    new_maillist: 'Nuova Mailing List',
    maillist: 'Mailing List',
    maillists: 'Liste Mail Marketing',
    mailmarketing_template: 'Template Mail Marketing',
    mailmarketing_templates: 'Template Mail Marketing',
    new_mailmarketing_template: 'Nuovo Template Mail Marketing',
    emailrecipient: 'Destinatario Mail Marketing',
    emailrecipients: 'Destinatari Mail Marketing',
    whatsapprecipient: 'Destinatario WhatsApp',
    whatsapprecipients: 'Destinatari Campagne WhatsApp',
    template: 'Template',
    new_template: 'Nuovo Template',
    campaign: 'Campagna',
    campaigns: 'Campagne',
    new_campaign: 'Nuova Campagna',
    failed: 'Fallita',
    delivered: 'Consegnata',
    accepted: 'Accettata',
    delivery_error: 'Errore consegna',
    opened: 'Letta',
    movementddts: 'DDT di Trasferimento',
    movementddt: 'DDT di Trasferimento',
    new_movementddt: 'Nuovo DDT di Trasferimento',
    warehouses: 'Magazzini',
    new_warehouse: 'Nuovo Magazzino',
    warehouse: 'Magazzino',
    warehouse_provenance: 'Magazzino di Provenienza',
    warehouse_destination: 'Magazzino di Destinazione',
    stocks: 'Giacenze',
    act: 'Act',
    mikrotik: 'Mikrotik',
    yellologs: 'Log',
    credential: 'Credenziali',
    credentials: 'Credenziali',
    new_credential: 'Nuove Credenziali',
    subscriptions: 'Abbonamenti',
    subscription: 'Abbonamento',
    new_subscription: 'Nuovo Abbonamento',
    productsubscription: 'Prodotti Abbonamento',
    document: 'Documento',
    documents: 'Documenti',
    invoice: 'Fattura',
    invoices: 'Fatture',
    'documents-saleinvoice': 'Fatture di Vendita',
    saleinvoices: 'Fatture di Vendita',
    saleinvoice: 'Fattura di Vendita',
    new_saleinvoice: 'Nuova Fattura di Vendita',
    saleinvoiceproduct: 'Prodotto Fattura di Vendita',
    proformainvoices: 'Fatture Proforma',
    proformainvoice: 'Fattura Proforma',
    new_proformainvoice: 'Nuova Fattura Proforma',
    proformainvoiceproduct: 'Prodotto Fattura Proforma',
    purchaseinvoices: 'Fatture di Acquisto',
    purchaseinvoice: 'Fattura di Acquisto',
    purchaseinvoiceproduct: 'Prodotto Fattura di Acquisto',
    new_purchaseinvoice: 'Nuova Fattura di Acquisto',
    edocuments: 'Documenti Elettronici',
    edocument: 'Documento Elettronico',
    new_edocument: 'Nuovo Documento Elettronico',
    selfinvoice: 'Autofattura',
    selfinvoices: 'Autofatture',
    new_selfinvoice: 'Nuova Autofattura',
    creditnote: 'Nota di Credito',
    creditnotes: 'Note di Credito',
    new_creditnote: 'Nuova Nota di Credito',
    debitnote: 'Nota di Debito a Fornitore',
    debitnotes: 'Note di Debito a Fornitore',
    new_debitnote: 'Nuova Nota di Debito a Fornitore',
    suppliercreditnote: 'Nota di Credito da Fornitore',
    suppliercreditnotes: 'Note di Credito da Fornitore',
    new_suppliercreditnote: 'Nuova Nota di Credito da Fornitore',
    cost: 'Costo',
    costs: 'Costi',
    new_cost: 'Nuova Costo',
    invoiceproduct: 'Prodotti Fatture di Vendita',
    selfinvoiceproduct: 'Prodotti Autofatture',
    creditnoteproduct: 'Prodotti Note di Credito',
    costproduct: 'Prodotti Costi',
    new_intent: 'Nuova Lettera di Intento',
    intent: 'Lettera di Intento',
    intents: 'Lettere di Intento',
    telephone_pricelists: 'Listini Telefonici',
    new_telephone_pricelist: 'Nuovo Listino Telefonico',
    telephone_pricelist: 'Listino Telefonico',
    cli: 'CLI Telefonico',
    new_cli: 'Nuovo CLI Telefonico',
    accountbalance: 'Estratto conto',
    accountbalances: 'Estratti conto',
    new_accountbalance: 'Nuovo Estratto conto',
    inventory: 'Inventario',
    sent: 'Inviata',
    pending: 'In attesa',
    sending: 'In Invio',
    summary: 'Riepilogo',
    reports: 'Report',
    container: 'Cassone',
    new_container: 'Nuovo Cassone',
    containers: 'Cassoni',
    new_integrationwebsite: 'Nuovo Website',
    integrationwebsite: 'Website',
    machinery: 'Macchinaro',
    machines: 'Macchinari',
    callqueues: 'Campagne',
    callqueue: 'Campagna',
    new_callqueue: 'Nuova Campagna',
    automations: 'Automazioni',
    automation: 'Automazione',
    new_automation: 'Nuova Automazione',
    audits: 'Audit',
    'configuration file already exists': 'File di configurazione già esistente',
    'certificate created successfully': 'File di configurazione creato correttamente',
    'bad request': 'Richiesta mal formata',
    'internal server error': 'Errore interno del server',
    read: 'Solo Lettura',
    write_owner: 'Lettura/Scrittura Proprietari',
    write: 'Lettura/Scrittura Tutto',
    containermovement: 'Movimentazione Cassone',
    containermovements: 'Movimentazioni Cassone',
    new_containermovement: 'Nuova Movimentazione Cassone',
    notify_expiring_asset_subtitle : 'Ricevi una notifica quando l\'asset sta per scadere',
    notify_expired_asset_subtitle : 'Ricevi una notifica quando un asset è scaduto',
    whatsapp: 'WhatsApp',
    whatsappconversations: 'Conversazioni WhatsApp',
    whatsappconversation: 'Conversazione WhatsApp',
    whatsapp_templates: 'Template WhatsApp',
    new_whatsapp_template: 'Nuovo Template WhatsApp',
    whatsappcampaigns: 'Campagne WhatsApp',
    whatsappcampaign: 'Campagna WhatsApp',
    new_whatsappcampaign: 'Nuova Campagna WhatsApp',
    emailcampaign: 'Campagna Email',
    emailcampaigns: 'Campagne Email',
    new_emailcampaign: 'Nuova Campagna Email',
    peccampaign: 'Campagna PEC',
    peccampaigns: 'Campagne PEC',
    new_peccampaign: 'Nuova Campagna PEC',
    whatsapplists: 'Liste WhatsApp',
    whatsapplist: 'Lista WhatsApp',
    new_whatsapplist: 'Nuova Lista WhatsApp',
    whatsapp_sent: 'Inviato',
    whatsapp_delivered: 'Consegnato',
    whatsapp_read: 'Letto',
    whatsapp_failed: 'Fallito',
    whatsapp_invalid: 'Non Valido',
    helpdesktroubles: 'Ticket Helpdesk',
    helpdesktrouble: 'Ticket Helpdesk',
    new_helpdesktrouble: 'Nuovo Ticket Helpdesk',
    helpdeskinterventions: 'Interventi Helpdesk',
    helpdeskintervention: 'Intervento Helpdesk',
    new_helpdeskintervention: 'Nuovo Intervento Helpdesk',
    helpdeskcontracts: 'Contratti Helpdesk',
    helpdeskcontract: 'Contratto Helpdesk',
    new_helpdeskcontract: 'Nuovo Contratto Helpdesk',
    helpdesktariffs: 'Tariffari Helpdesk',
    helpdesktariff: 'Tariffario Helpdesk',
    new_helpdesktariff: 'Nuovo Tariffario Helpdesk',
    financial_account: 'Conto Finanziario',
    product_brand: 'Brand',
    planners: 'Pianificatore'
    
}
